import { MdOutlineKeyboardArrowRight } from 'react-icons/md';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useMemo, useState, type JSX } from 'react';
import { ActiveSearchBar } from '@/components/widgets';
import {
  POPULAR_SEARCH_HEADING,
  POPULAR_SEARCH_TAGS,
  RIGHT_ARROW_SIZE,
} from './SearchSuggestionPage.constants';
import styles from './SearchSuggestionPage.module.css';

const SearchSuggestionPage = (): JSX.Element => {
  const [query, setQuery] = useState<string | null>(null);
  const location = useLocation();
  const navigate = useNavigate();
  const params = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );
  const createCurationFlag = params.has('createCurations');

  useEffect(() => {
    setQuery(params.get('query'));
  }, [params]);

  const handleClick = (tag: string): void => {
    navigate(
      `/search?query=${tag}${createCurationFlag ? '&createCurations' : ''}`
    );
  };

  return (
    <div className={styles.container}>
      <ActiveSearchBar
        activeInitially={true}
        initialSearchText={query ?? undefined}
      />
      <div className={styles.popularSearchContainer}>
        <div className={styles.popularSearchHeading}>
          {POPULAR_SEARCH_HEADING}
        </div>
        <div className={styles.popularTagsContainer}>
          {POPULAR_SEARCH_TAGS.map((tag, idx) => (
            <div
              key={idx}
              className={styles.popularTag}
              onClick={() => handleClick(tag)}
            >
              <span>{tag}</span>
              <MdOutlineKeyboardArrowRight
                className={styles.arrowRight}
                size={RIGHT_ARROW_SIZE}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SearchSuggestionPage;
